import { PersonalProfile } from '../types';

interface HeaderProps {
  profile: PersonalProfile;
}

function Header({ profile }: HeaderProps) {
  return (
    <header id="fh5co-header" className="fh5co-cover js-fullheight" role="banner" style={{ backgroundImage: 'url(images/cover_bg_3.jpg)' }} data-stellar-background-ratio="0.5">
      <div className="overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center">
            <div className="display-t js-fullheight">
              <div className="display-tc js-fullheight animate-box" data-animate-effect="fadeIn">
                <div className="profile-thumb" style={{ background: `url(${profile.profileImage})` }}></div>
                <h1><span>{profile.name}</span></h1>
                <h3><span>{profile.title}</span></h3>
                <p style={{ marginTop: '25px' }}>
                  <ul className="fh5co-social-icons">
                    {profile.socialLinks.map((link) => (
                      <li key={link.url}><a href={link.url}><i className={link.icon}></i></a></li>
                    ))}
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
